import React from 'react'
import { AppContext } from "contexts/AppContext";
import { useContext, useState } from 'react'
import RegisterForm from './RegisterForm'
import RegisterSuccess from './RegisterSuccess'
import RegisterError from './RegisterError'
import "./Register.css"
import RegisterCreated from './RegisterCreated';
import RegisterPageBanner1 from 'components/blocks/registerPageBanner/RegisterPageBanner1';
import { Box, Grid2 as Grid } from '@mui/material';
import SectionWrapper from 'components/layouts/SectionWrapper';
import ContentNormal from 'components/elements/ContentNormal';
import Headline5 from 'components/elements/Headline5';
import NewRegisterPage from './NewRegisterPage';
import NewRegisterConfirmation from './NewRegisterConfirmation';
import { Link } from 'react-router-dom';
import Translate from 'utils/Translate';

const Register = () => {
    const { brandData, langCode, styleGuide } = useContext(AppContext);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [mobilePhoneNumber, setMobilePhoneNumber] = useState('');
    const brandSlug = brandData?.brandSlug;
    const {frontPageBannerContent, frontPageBannerTitle, frontPageTextColorBlack, registerUser}= brandData?.features
    const automaticApproval = registerUser?.automaticApproval;
    const registerPageTitle = registerUser?.registerPageTitle;
    const registerPageDescription = registerUser?.registerPageDescription;
    const registerTitle = registerPageTitle || (frontPageBannerTitle && typeof frontPageBannerTitle === 'object' ?
                    frontPageBannerTitle.hasOwnProperty(langCode) ? frontPageBannerTitle[langCode] : '' : frontPageBannerTitle ? frontPageBannerTitle : '')
    const registerDescription = registerPageDescription || (frontPageBannerContent && typeof frontPageBannerContent === 'object' ?
                    frontPageBannerContent.hasOwnProperty(langCode) ? frontPageBannerContent[langCode] : '' : frontPageBannerContent ? frontPageBannerContent : '')

    if (brandData?.features?.useNewLoginPage) {
        return (
            <NewRegisterPage title={registerTitle} description={registerDescription}>
                {!success && !error && (
                    <RegisterForm modern setError={setError} setSuccess={setSuccess} setMobilePhoneNumber={setMobilePhoneNumber} />
                )}
                {success && <NewRegisterConfirmation automaticApproval={!!automaticApproval} mobilePhoneNumber={mobilePhoneNumber} />}
                {error && (
                    <>
                        <RegisterError errorMessage={<Translate translationKey="_REGISTER_ALREADY_EXISTS_">Du er allerede oprettet i klubben.</Translate>} />
                        <Link to="/login"><Translate translationKey="_LOGIN_PAGE_LOGIN_TEXT_">Log ind</Translate></Link>
                    </>
                )}
            </NewRegisterPage>
        );
    }

    return (
        <div>
            <RegisterPageBanner1
                title={registerTitle}
                text={registerDescription}
                textColor={!!frontPageTextColorBlack ? styleGuide.color18 : styleGuide.color1}
            />
            <SectionWrapper>
                <Box display={'flex'} flexWrap={'wrap'} paddingTop={{xs: 2, md: 8}} columnGap={10} paddingBottom={8}>
                    <Box flex={1} minWidth={320}>
                        {!success && !error && <RegisterForm setError={setError} setSuccess={setSuccess} setMobilePhoneNumber={setMobilePhoneNumber} />}
                        {success && !automaticApproval && <RegisterSuccess />}
                        {success && !!automaticApproval && <RegisterCreated mobilePhoneNumber={mobilePhoneNumber} />}
                        {error && <RegisterError
                            errorMessage='Du er allerede oprettet i klubben.'
                            subMessage={`Venligst log ind på <a class='link' href='http://${brandSlug}.upgrader.club'>${brandSlug}.upgrader.club</a>`}
                        />}
                    </Box>

                    <Box flex={1} display={'flex'} flexDirection={'column'} gap={2} minWidth={320} paddingBottom={10}>
                        {!success &&
                            <Box display={'flex'} alignItems={'center'} gap={4}>
                                <Box display={'flex'} flexDirection={'column'} gap={1}>
                                    <Headline5
                                        translationKey="_CONTACT_INFORMATION_"
                                        fallbackText="Kontakt information"
                                    />
                                    {!!brandData?.features?.registerUser?.contactPersonName &&
                                        <ContentNormal style={{fontWeight: 500}}>
                                            {brandData?.features?.registerUser?.contactPersonName}
                                        </ContentNormal>
                                    }

                                    {!!brandData?.contactEmail &&
                                        <ContentNormal style={{fontWeight: 500}}>
                                            {brandData.contactEmail}
                                        </ContentNormal>
                                    }

                                    {!!brandData?.contactPhone &&
                                        <ContentNormal style={{fontWeight: 500}}>
                                            {brandData.contactPhone}
                                        </ContentNormal>
                                    }
                                </Box>

                                <Box>
                                    {!!brandData?.features?.registerUser?.contactPersonImageUrl &&
                                        <img src={brandData?.features?.registerUser?.contactPersonImageUrl} width={120} height={120} />
                                    }
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>
            </SectionWrapper>
            
        </div>
    )
}

export default Register